import React, {useContext, useState} from 'react';
import {Grid, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {useFormikContext} from 'formik';
import {styled} from '@mui/styles';
import {uploadAction, uploadPhoto} from '../../services/PhotoServices';
import {SNACKBAR_OPEN} from '../../reducers';
import {DispatchContext} from '../../store';
import {Images} from '../Assets/Images';

const Input = styled('input')({
  display: 'none',
});
export const MultipleImageUpload = ({setImageId, imgId, acquisitionImgIds}) => {
  const dispatch = useContext(DispatchContext);
  const [images, setImages] = useState([]);
  const {values, setFieldValue} = useFormikContext();
  const id = parseInt(imgId);

  const handleAddMuseumPhoto = ({target: {files}}, index) => {
    const newImages = Array.from(files)
      .slice(0, 5 - images.length)
      .map(file => URL.createObjectURL(file));

    const image = files[0];
    const formData = new FormData();
    formData?.append('file', image);

    uploadPhoto('post', null, formData, {'Content-Type': 'multipart/form-data'}).then(res => {
      setImageId(prevArtefactImgIds => [...prevArtefactImgIds, res?.data?.id]);

      const newPhoto = {id: res?.data?.id, file: res?.data?.file};

      if (imgId) {
        if (values?.attachments) {
          values?.attachments.push(newPhoto);
          setFieldValue('photos', [...values?.attachments]);
        } else {
          setFieldValue('photos', [...values?.photos, newPhoto]);
        }
      }
    });
    setImages(prevImages => [...prevImages, ...newImages]);
  };

  const handleRemoveImage = async (index, id) => {
    try {
      if (imgId) {
        await uploadAction('delete', id);
      }

      setImageId(prevArtefactImgIds => prevArtefactImgIds.filter(imgId => imgId !== id));

      let updatedPhotos;

      if (values?.attachments) {
        updatedPhotos = values?.attachments?.filter(photo => photo?.id !== id);
      } else {
        updatedPhotos = values?.photos?.filter(photo => photo.id !== id);
      }
      setFieldValue('photos', updatedPhotos);
      setFieldValue('attachments', updatedPhotos);

      if (!imgId) {
        setImages(prevImages => prevImages.filter((image, i) => i !== index));

        const imageIdToDelete = acquisitionImgIds[index];
        await uploadAction('delete', imageIdToDelete);

        const updatedImagesState = [...acquisitionImgIds];
        updatedImagesState.splice(index, 1);
        setImageId(updatedImagesState);
      }

      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Image removed successfully'}
      });
    } catch (error) {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'error', message: 'Error removing image: ' + error}
      });
    }
  };


  return (
    <React.Fragment>
      <Box sx={{position: 'relative', mt: 1}}>
        <label htmlFor="cover-button-file" className="hand-cursor">
          <Box style={{
            border: '1px dashed #929191',
            width: '100%',
            minHeight: 120,
            height: 'auto',
            objectFit: 'contain',
            borderRadius: 5
          }}>
            <Grid container spacing={2} sx={{p: 1}}>
              {(values?.photos || values?.attachments || images)?.map((image, index) => (
                <Grid key={index} item sm={2.4}>
                  <div>
                    <img draggable={false} width={'80%'} height={55}
                         style={{objectFit: 'cover'}}
                         src={image?.file || image?.data?.file || image || Images?.logoWhite}
                         alt="museum_photo"/>
                    {/*{typeof image === 'string' && image.match(/\.(jpeg|jpg|gif|png)$/) !== null ? (*/}
                    {/*  <img*/}
                    {/*    draggable={false}*/}
                    {/*    width={'80%'}*/}
                    {/*    height={55}*/}
                    {/*    style={{ objectFit: 'cover' }}*/}
                    {/*    src={image}*/}
                    {/*    alt="museum_photo"*/}
                    {/*  />*/}
                    {/*) : (*/}
                    {/*  <a href={image} target="_blank" rel="noreferrer">*/}
                    {/*    att {index + 1}*/}
                    {/*  </a>*/}
                    {/*)}*/}
                    {id ?
                      <IconButton
                        onClick={() => handleRemoveImage(index, image?.id)}
                        aria-label="delete"
                      >
                        <RemoveCircleIcon sx={{color: 'red'}}/>
                      </IconButton> :
                      <IconButton
                        onClick={() => handleRemoveImage(index)}
                        aria-label="delete"
                      >
                        <RemoveCircleIcon sx={{color: 'red'}}/>
                      </IconButton>
                    }
                  </div>
                </Grid>
              ))}
            </Grid>
          </Box>
          <label className="hand-cursor" style={{position: 'absolute', bottom: '30%', left: '35%'}}>
            <Input accept="image/*" id="cover-button-file" type="file" multiple
                   onChange={(e) => handleAddMuseumPhoto(e, values?.photo_ids?.length)}/>
            {(values?.photo_ids || values?.attachments || images)?.length === 0 && (
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} color="primary"
                   aria-label="upload picture">
                <CloudUploadIcon sx={{color: '#343434'}}/>
                <Typography sx={{color: '#343434'}}>Upload picture</Typography>
              </div>)}
          </label>
        </label>
      </Box>
    </React.Fragment>
  );
};
